import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
//@ts-ignore
import img from '@Images/en/army_folder.png';
import {FolderView} from "@Selectors/builder/myBuilder/show/view/FolderView";
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';

interface IFolderComponentProps {
  folder: FolderView
}

const FolderComponent: React.FC<FolderComponentProps> = ({folder}) => {
  return (
    <Col xs={6} md={3} xl={2} className="army_list_row text-center">
      <Link to={`/${document.documentElement.lang}/builder/folders/${folder.id}`}>
        <img className="img-fluid w-100" alt='' src={`${process.env.CDN ?? ''}${img}`}/>
        <h4 className="boxtitre">{(folder.name || '').substring(0, 60)}</h4>
      </Link>
    </Col>
  );
};

const mapStateToProps = (state: AppState, owsProps: IFolderComponentProps) => ({
  folder: owsProps.folder
})

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FolderComponent);

type FolderComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
